import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/pro-regular-svg-icons';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import dayjs from '@/domain/mitarbeiter/shared/utils/dayjs';

export function YearNavigationHeader({ jahr }: { jahr: string }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleTodayClick = () => {
    const year = dayjs(new Date()).get('year');
    navigate(`/mitarbeiter/rotationsplaene/planung?year=${year}`, {
      replace: true,
    });
  };

  const handlePrevYearClick = () => {
    const year = dayjs(jahr).subtract(1, 'year').get('year');
    navigate(`/mitarbeiter/rotationsplaene/planung?year=${year}`, {
      replace: true,
    });
  };

  const handleNextYearClick = () => {
    const year = dayjs(jahr).add(1, 'year').get('year');
    navigate(`/mitarbeiter/rotationsplaene/planung?year=${year}`, {
      replace: true,
    });
  };

  return (
    <div className="flex items-center gap-4">
      <Button onClick={handleTodayClick} variant="outline-secondary">
        {t('general.date.today')}
      </Button>
      <div className="flex items-center">
        <Button size="icon" variant="icon" onClick={handlePrevYearClick}>
          <FontAwesomeIcon
            className="text-neutrals-700 text-xl"
            icon={faChevronLeft}
          />
        </Button>
        <Button size="icon" variant="icon" onClick={handleNextYearClick}>
          <FontAwesomeIcon
            className="text-neutrals-700 text-xl"
            icon={faChevronRight}
          />
        </Button>
      </div>
      <div className="text-xl font-semibold">{jahr}</div>
    </div>
  );
}
